import { gql } from '@apollo/client';
import { AIRPORT_BASIC_FRAGMENT, AIRPORT_DETAIL_FRAGMENT } from '../fragments';

export const LIST_AIRPORTS_MINIMAL = gql`
  query ListAirportsMinimal(
    $filter: AirportFilterInput
    $sort: AirportSortInput
    $pagination: PaginationInput
  ) {
    airports(filter: $filter, sort: $sort, pagination: $pagination) {
      edges {
        node {
          ...AirportBasic
        }
        cursor
      }
      pageInfo {
        currentPage
        totalPages
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
  ${AIRPORT_BASIC_FRAGMENT}
`;

export const GET_AIRPORT_DETAIL = gql`
  query GetAirportDetail($id: ID!) {
    airport(id: $id) {
      ...AirportDetail
    }
  }
  ${AIRPORT_DETAIL_FRAGMENT}
`;

export const GET_AIRPORTS_MINIMAL = gql`
  query GetAirportsMinimal($ids: [ID!]!) {
    airportsByIds(ids: $ids) {
      ...AirportBasic
    }
  }
  ${AIRPORT_BASIC_FRAGMENT}
`;

export const GET_USER_AIRPORT_STATS = gql`
  query GetUserAirportStats(
    $filter: UserAirportStatsFilterInput
    $sort: UserAirportStatsSortInput
    $pagination: PaginationInput
  ) {
    userAirportStats(filter: $filter, sort: $sort, pagination: $pagination) {
      edges {
        node {
          airport {
            ...AirportBasic
          }
          flightCountPast
          flightCountFuture
          lastFlightDate
        }
        cursor
      }
      pageInfo {
        currentPage
        totalPages
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
  ${AIRPORT_BASIC_FRAGMENT}
`; 